<template>
  <ProSpaceRightPanel
    v-if="ids.length > 0"
    :header="header"
    :loading="loading"
    :has-error="hasError"
    @clear="clearPanel"
    @edit="editPanel"
    @delete="deletePanel"
    @show-history="showHistoryPanel"
  >
    <template v-if="ids.length === 1" v-slot:center>
      <ProSpacePanelBlock :header="headerOverview">
        <template v-slot:header>
          <ProSpaceAction :text="$t('editItemTxt')" @click="onClickEdit"/>
        </template>
        <template v-slot>
          <ProSpacePanelBlockList :list="content" />
        </template>
      </ProSpacePanelBlock>
    </template>
    <template v-if="ids.length === 1" v-slot:bottom>
      <ProSpacePanelBlock :header="headerBottom">
        <template v-slot>
          <ProSpacePanelBlockList :list="contentBottom" />
        </template>
      </ProSpacePanelBlock>
    </template>
  </ProSpaceRightPanel>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceAction
} from "@prospace/prospace-components-library";
import { SystemDirectoryService } from "../../../services/SystemDirectoryService";
import { mapGetters } from "vuex";
import {getAMorPM} from "@prospace/prospace-components-library/src/lib-assets/mixins/date";

export default {
  name: "SystemDirectoryPanel",
  components: {
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceAction
  },
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    ids: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      systemdirectory: null,
      systemdirectoryService: new SystemDirectoryService(),
      loading: false,
      hasError: false,
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDateTime: "userinfoStore/getFormatDateTime",
    }),
    headerOverview() {
      return {
        title: this.$t("parameters"),
        isExpand: false,
      };
    },
    headerBottom() {
      return {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      };
    },
    header() {
      if (this.systemdirectory) {
        return {
          title: this.systemdirectory.name,
          id: this.systemdirectory.id,
          options: this.options,
          showCounter: false,
        };
      }
      return {
        title: this.$t("itemsSelected"),
        counter: this.ids.length,
        showCounter: true,
      };
    },
    content() {
      if (this.systemdirectory) {
        return [
          [
            {
              title: this.$t("name"),
              text: this.systemdirectory.name,
            },
          ],
        ];
      }
      return [];
    },
    contentBottom() {
      let metaInfo = [];
      if (this.systemdirectory) {
        metaInfo.push([
          {
            title: this.$t("createdByTxt"),
            text: this.systemdirectory.createdBy,
          },
          {
            title: this.$t("updatedByTxt"),
            text: this.systemdirectory.updatedBy,
          },
        ]);

        metaInfo.push([
          {
            title: this.$t("createdAtTxt"),
            text: this.getFormatDateTime(this.systemdirectory.createdAt) + ' ' + getAMorPM(this.systemdirectory.createdAt, this.userinfo?.timeFormat),
          },
          {
            title: this.$t("lastUpdatedTxt"),
            text: this.getFormatDateTime(this.systemdirectory.lastUpdated) + ' ' + getAMorPM(this.systemdirectory.lastUpdated, this.userinfo?.timeFormat),
          },
        ]);
      }
      return metaInfo;
    },
  },
  mounted() {
    this.update();
  },
  methods: {
    onClickEdit() {
      this.$emit("edit", this.systemdirectory)
    },
    update() {
      this.hasError = false;
      try {
        this.getSystemDirectory();
      } catch (e) {
        this.hasError = true;
      }
    },
    getSystemDirectory() {
      if (this.ids.length === 1) {
        this.loading = true;
        this.systemdirectoryService.get(this.ids[0]).then((res) => {
          this.systemdirectory = res.data;
          this.loading = false;
        });
      }
      this.systemdirectory = null;
    },
    clearPanel() {
      this.$emit("clear");
    },
    editPanel() {
      this.$emit("edit", this.systemdirectory);
    },
    deletePanel() {
      this.$emit("delete", this.systemdirectory);
    },
    showHistoryPanel() {
      this.$emit("history", this.systemdirectory);
    },
  },
  watch: {
    ids() {
      this.update();
    },
  },
};
</script>

<style scoped></style>
